import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';

import { LocalStoreService } from './local-store.service';
import { environment } from '../../../environments/environment';
import { UserService } from './user.service';
import { UserModel } from '../models/user.model';
import { WebsocketService } from './websocket.service';
import * as PusherPushNotifications from "@pusher/push-notifications-web";
import { NotificationService } from './notification.service';
import { ROLES } from 'src/environments/constants';


@Injectable({
  providedIn: 'root'
})
export class AuthService{
  // Only for demo purpose
  triggered:boolean = false;
  initialTimeout:any;
  authenticated = false;
  token : any;
  isForgotPassword = false;
  user:UserModel; 
  didFirstCheck:boolean = false;
  private companyLogo:string ="/assets/img/web-logo.png";

   beamsClient;


  constructor(
    private http: HttpClient,
     private store: LocalStoreService,
     private userService : UserService,
     private router : Router,
     private wsService : WebsocketService,
	 public notificationService: NotificationService) {
     //this.checkAuth();
  }


  timeout;



  getFavicon(){
    return "/assets/fav.png";  
  }

  getBackground(){
	return "/assets/background.jpg";  
  }

  permissions:any[];

  hasPermission(permission_name: string) {
    if(!this.permissions){
      if(this.store.getItem('currentUser')){
        console.log(this.store.getItem('currentUser'));
        this.permissions = this.store.getItem('currentUser')['permissions'];
      }
    }
    if(this.permissions){
      
        return true;
      
    }
    else{
		//this.signout();
		return true;
      
    }
    return false;
  }

  getLogo(withTagline?){
    // if(withTagline){
    //   return "/assets/img/logo_with_tagline.svg";
    // }
    return "/assets/Logo.png";
  }

  checkAuth() {
    //this.authenticated = !!this.store.getItem('currentUser');
    if(!this.store.getItem('currentUser')){
      this.authenticated = false;
      return;
    }
    else{
      let _this = this;
      
      this.token = this.store.getItem('currentUser')['token'];
      this.userService.get(this.store.getItem('currentUser')['id']).subscribe(res => {
       console.log('authenticated');
	    _this.didFirstCheck = true; 
        _this.authenticated = true;
        _this.user = this.store.getItem('currentUser');
        //_this.wsService.listenChannel("private-user-channel-",this.getUserId());
      },
      err => {
		 // console.log('test');
        _this.didFirstCheck = true;
        this.signout();
      })
    }
  }

  getUser() {
    return this.store.getItem('currentUser');
  }

  getUserId(){
    const user : any = this.store.getItem('currentUser');
    if(!user){
      return null;
    }
    return user.id;
  }

  getSystemRoles(){
    return this.http.get(`${environment.baseUrl}/systemroles`);
  }

//   getUserRole() {
//     const user: any = this.store.getItem('currentUser');
//     if(!user){
//       return null;
//     }
//     return user.system_role[0].id;
//   }

  forgotToken(username){
    return this.http.post(`${environment.baseUrl}/auth/forgot/request`,{email:username});
  }

  forgotUpdate(formData){
    return this.http.post(`${environment.baseUrl}/auth/forgot/password`,formData);
  }

  updateCredentials(formData){
    return this.http.put(`${environment.baseUrl}/user/profile`,formData);
  }

  signin(credentials) {
    return this.http.post<any>(`${environment.baseUrl}/auth/login`, { email: credentials.email, password: credentials.password });
  }

  forgotPassword(credentials) {
    return this.http.post<any>(`${environment.baseUrl}/auth/password/reset`, { email: credentials.email, password: credentials.password, password_confirmation:  credentials.password_confirmation, token: credentials.token});
  }

  resetPassword(credentials) {
    return this.http.post<any>(`${environment.baseUrl}/auth/password/reset`, { email: credentials.email, password: credentials.password, password_confirmation:  credentials.password_confirmation, token: credentials.token});
  }

  getRolePermissions(roleId){
    let permission_types:string[] = [];
    let permission_names:string[] = [];
    let permissions:string[] = [];


    if(roleId == 1){//Admin
      permission_types = ["create","update","delete","view"];
      permission_names = ["location","guest","user","jobsheets","absence","project","employee"];
      //permissions.push("view_settings");
    }else{
		permission_types = ["create","update","delete","view"];
		permission_names = ["report","timesheet","client","project","employee"];
	  }


    for(let type of permission_types){
      for(let perm_name of permission_names){
        permissions.push(type+"_"+perm_name);
      }
    }
    
    return permissions;
  }

  isAdmin() {
    return this.getUser()['system_role']['id'] == ROLES.ADMIN;
  }

  isAgent() {
    return this.getUser()['system_role']['id'] == ROLES.AGENT;
  }

  isAccountant() {
    return this.getUser()['system_role']['id'] == ROLES.ACCOUNTANT;
  }

  signout() {
	console.log("Signing Out!");
    let _this = this;
    this.authenticated = false;
    this.didFirstCheck = false;
    //this.activeCompany = null;
    _this.store.setItem('currentUser', null);
    _this.router.navigate(['/session/login']);
  }
  
  getSettings(){
    return this.http.get(`${environment.baseUrl}/systemsettings`);
  }

  putSettings(formData){
    return this.http.put(`${environment.baseUrl}/systemsettings`,formData);
  }

}
